import React from 'react';
import { Chip, ChipProps, styled, Theme } from '@material-ui/core';

const StyledChip = styled(Chip)(
  ({ theme, isInternal }: { theme: Theme; isInternal?: boolean }) => ({
    // dlr theme has background override for DataGrid, so we need to use !important to override it
    backgroundColor: `${isInternal ? 'transparent' : theme.palette.lightBlue}`,
    color: theme.palette.primary.main,
    border: isInternal ? `1px solid ${theme.palette.primary.main}` : 'none',
    margin: 4,
  }),
);

export const CustomChip = ({
  isInternal,
  ...props
}: ChipProps & { isInternal?: boolean }) => {
  return <StyledChip isInternal={isInternal} {...props} />;
};
